import { render, staticRenderFns } from "./TeamMembersModal.vue?vue&type=template&id=54ab7a26&"
import script from "./TeamMembersModal.vue?vue&type=script&lang=js&"
export * from "./TeamMembersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports